<!-- 库存打印 -->
<template>
    <div class="xform">
        <!-- <el-row :gutter="10" type="flex" justify="space-between" align="center" >
           
            <el-col :xs="15">
                <div style="display:flex;">
                    <div style="white-space:nowrap;">{{msg('批量填充')}}： </div>
                    <el-input style="max-width:200px;" size="mini" :placeholder="msg('输入要填充的值')" v-model="iptValue" >
                    </el-input>
                    <el-button size="mini" icon="el-icon-check" @click="fillValue"></el-button>
                </div>
            </el-col>
        </el-row> -->
        <div style="display:flex;margin-top:20px;margin-bottom:10px;align-items:center;justify-content:center;">
            <el-button type="primary" size="mini"  @click="doPrint"><i class="el-icon-printer"></i><span>{{msg('打印')}}</span></el-button>
        </div>
        <div class="table-wrap">
            <vxe-table :data="datas"
                    export-config stripe
                    resizable border="full"
                    highlight-current-row highlight-hover-column highlight-current-column
                    show-overflow show-header-overflow 
                    :max-height="500" 
                    :edit-config="{trigger: 'click', mode: 'cell'}"
                    :scroll-y="{gt: 50}"
                    style="width: 100%" ref="dataTable" >
                <vxe-table-column field="code" :title="msg('订单编号')" min-width="120"></vxe-table-column>
                <vxe-table-column field="total" :title="msg('打印票数')" min-width="120"
                    :edit-render="{name: 'input', attrs: {type: 'number'}}"
                ></vxe-table-column>
            </vxe-table>
        </div>

        <div style="width:300px; text-align:center;" >
            <vue-easy-print ref="easyPrint" tableShow>
                <template>
                    <div v-for="(data, index) in datas" :key="index">
                        <div v-if="type === 0" class="vw200" :key="index+'1'" style="text-align:center;">
                            <div style="padding-top:0px;font-size: 15px; font-weight:bold;  line-height:90%;">{{data.shelfCode}}</div>
                            <img style="max-width:95%; padding-left:5px;" :src="data.barcodeAsBase64"/>
                            <div style="font-size: 16px; line-height:90%;padding-top:1px;">{{data.code}}</div>
                            <div style="font-size: 13px; line-height:90%;">{{data.inStoreDate}}</div>
                        </div>

                        <div v-else-if="type == 1" class="vw200" :key="index+'2'" style="text-align:center;">
                            <img style="max-width:95%; padding-left:5px; padding-top:5px;" :src="data.barcodeAsBase64"/>
                            <div style="font-size: 20px; line-height:100%;">{{data.code}}</div>
                            <div style="font-size: 15px; line-height:100%;">{{data.inStoreDate}}</div>
                        </div>

                        <div v-else-if="type == 2" class="vw400" :key="index+'3'" style="text-align:center;">
                            <div style="padding-top:0px;font-size: 30px; font-weight:bold; line-height:90%;">{{data.shelfCode}}</div>
                            <img style="max-width:95%; padding-left:5px; padding-top:1px;" :src="data.barcodeAsBase64"/>
                            <div style="font-size: 20px; line-height:90%;">{{data.code}}</div>
                            <div style="font-size: 15px; line-height:90%;">{{data.inStoreDate}}</div>
                            <div style="font-size: 15px; text-align:left; padding-top:5px; line-height:100%;"><span style="font-weight:bold;">标题：</span>{{data.title}}</div>
                            <div style="font-size: 15px; text-align:left; padding-top:5px; line-height:100%;"><span style="font-weight:bold;">规格：</span>{{data.spec}}</div>
                            <div style="font-size: 15px; text-align:left; padding-top:5px; line-height:100%;"><span style="font-weight:bold;">SKU：</span>{{data.sku}}</div>
                            <div style="font-size: 15px; text-align:left; padding-top:5px; line-height:100%;"><span style="font-weight:bold;">货号：</span>{{data.variationSku}}</div>
                        </div>

                        <div v-if="type === 3" class="vw200" :key="index+'1'" style="text-align:center;">
                            <div style="padding-top:0px;font-size: 15px; font-weight:bold;  line-height:90%;">{{data.shelfCode}}</div>
                            <img style="max-width:95%; padding-left:5px;" :src="data.barcodeAsBase64"/>
                        </div>

                        <div class="next-page a2" v-if="datas.length>1" :key="index+'4'"></div>
                        
                    </div>
                </template>
            </vue-easy-print>
        </div>

    </div>
</template>

<script>
import vueEasyPrint from "vue-easy-print";
export default {
    name: "StockPrintTag",
    components: {
        vueEasyPrint: vueEasyPrint,
    },
    // mounted(){
    //     this.getData();
    // },
    data(){
        return {
            datas: null,
            iptValue: null,
            total: 0,
            ids:null,
            type:null,
        }
    },
    props:{
    },
    methods:{
        init(ids,type){
            this.ids = ids;
            this.type = type;
            this.getData();
        },
        blockStyle(datas){
            if(datas && datas.length > 1){
                return {
                    display: "block",
                }
            }else{
                return {
                    display: "inline-block",
                }
            }
        },
        qtyChange ({ column }) {
            this.total = 0;
            setTimeout(()=>{
                this.datas.forEach((d)=>{
                    
                    this.total +=  d.total*1 || 0;
                });
            }, 100)
        },
        fillValue(){
            this.datas.forEach(d => {
                d.total = this.iptValue;
            })
        },
        getData(){  //初始化数据
            console.log(this.ids);
            this.$axios.post(this.$kit.api.inventory.printTag+"?type="+this.type,this.ids)
                .then((result) => {
                    if(result.status){
                        // result.data.forEach((d)=>{
                        //     this.total +=  d.total || 0;
                        // });
                        this.datas = result.data;
                        if(this.datas && this.datas.length > 0){
                            this.doPrint();
                        }
                    }
                });
        },
        doPrint(){
            this.$nextTick(() => {
                setTimeout(()=>{
                    this.$refs.easyPrint.print();
                }, 200);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.next-page {
  page-break-after: always;
}
.vw200{width:200px; margin:0px auto;}
.vw400{width:400px; margin:0px auto;}
</style>